// Dependencies
import LazyLoad from 'vanilla-lazyload';

// Vendors
import { documentReady } from './vendors/events';

// Elements
import Modal from '../components/elements/modal';
import Carousel from '../components/elements/carousel';
import Image from '../components/elements/image';
import Language from '../components/elements/language';
import Tooltip from '../components/elements/tooltip';
import CopyLink from '../components/elements/copylink';
import LinkDropdown from '../components/elements/linkdropdown';

// Blocks
import Block from '../components/blocks/block';
import CookieConsent from '../components/layout/cookieconsent';
import Accordion from '../components/blocks/accordion';
import Feature from '../components/blocks/feature';
import Gallery from '../components/blocks/gallery';
import Blog from '../components/blocks/blog';
import Whitepaper from '../components/blocks/whitepaper';
import RelatedEntries from '../components/blocks/relatedentries';
import Jobs from '../components/blocks/jobs';
import JobsApi from '../components/blocks/jobsapi';

// Layout
import Header from '../components/layout/header/default';

!window.app && console.error('Application: window.app object required.');

const extractYouTubeId = function (url) {
  const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
  const matches = url.match(regex);
  return matches ? matches[1] : null;
}

// HTML document has been load and DOM is ready
documentReady(() => {
  new Block();

  new Header();
});

// Page is fully loaded, including all css, objects, images
window.onload = () => {
  let lazyLoad = new LazyLoad({
    /* eslint-disable */
    elements_selector: '[data-srcset]',
    threshold: 150,
    class_loaded: 'loaded',
    data_srcset: 'srcset'
    /* eslint-enable no-alert */
  });

  new Carousel(lazyLoad);

  new CookieConsent();

  new Image();

  new Accordion();

  new Tooltip({
    targetDistance: -6 // px
  });

  new CopyLink();

  new Language();

  new Feature();

  new Gallery();

  new Blog(lazyLoad);

  new Whitepaper(lazyLoad);

  new LinkDropdown();

  new RelatedEntries(lazyLoad);

  new Jobs();

  new JobsApi();

  Modal.init();

  // Scroll to element (deducting sticky header's height)
  let anchorLinks = document.querySelectorAll('a[href^="#"]') || null;
  if (anchorLinks) {
    let headerElement = document.querySelector('.header--sticky') || null;
    if (headerElement) {
      for (let item of anchorLinks) {
        item.addEventListener('click', (event) => {
          let hashValue = item.getAttribute('href');
          let target = document.querySelector(hashValue) || document.querySelector(`a[name="${hashValue.substring(1)}"]`) || false;
          let scrollTop = window.scrollY || 0;
          if (target) {
            window.scrollTo({
              top: (target.getBoundingClientRect().top + scrollTop) - headerElement.offsetHeight - 20,
              behavior: 'smooth'
            });
            history.pushState(null, null, hashValue);
            event.preventDefault();
          }
        });
      }
    }
  }

  // scroll element into view on page load
  const scrollIntoViewElements =  document.querySelectorAll('[data-scrollintoview]');
  scrollIntoViewElements.forEach((element) => {
    setTimeout(() => {
      window.scrollTo({
        top: window.scrollY + element.getBoundingClientRect().top - 200,
        behavior: 'smooth'
      });
    }, 200);
  });

};

document.addEventListener('DOMContentLoaded', function() {
  if (window.location.hash && window.location.hash !== '') {
    const hashTarget = document.querySelector(window.location.hash);
    if (hashTarget !== null) {
      window.scrollTo({
        top: window.scrollY + hashTarget.getBoundingClientRect().top - 200,
        behavior: 'smooth'
      });
    }
  }

  const oembedElements = document.querySelectorAll('oembed[url]');
  //console.log(oembedElements);

  oembedElements.forEach(element => {
    const videoWrapper = document.createElement('div');
    const url = element.getAttribute('url');

    element.classList.add('video__embed');
    element.style.display = 'block';

    // Get the parent section
    const parentSection = document.querySelector('main');

    // Retrieve the value of the data attribute
    const headline = parentSection.getAttribute('data-fallback-headline');
    const copy = parentSection.getAttribute('data-fallback-copy');
    const cta = parentSection.getAttribute('data-fallback-cta');


    // Create the fallback HTML
    const fallbackHTML = `
        <div class="cookie-consent__fallback row center-xs middle-xs">
            <div class="col-xs-12 text--align-center text--size-small">
                <h6 class="headline headline--3">${headline}</h6>
                <p>${copy}</p>
                <footer class="button-group button-group--vertical">
                    <a class="button button--primary button__fallback" id="consentTrigger" href="#cookie-consent">
                        <span class="button__text">${cta}</span>
                    </a>
                </footer>
            </div>
        </div>`;

    element.insertAdjacentHTML('beforeend', fallbackHTML);

    videoWrapper.classList.add('videowrapper');
    videoWrapper.dataset.video = extractYouTubeId(url);

    // Insert the video wrapper after the element
    element.after(videoWrapper);
  });

  window.addEventListener('app.cookieConsent.onChange', event => {
    oembedElements.forEach(element => {
      const url = element.getAttribute('url');
      if (!url) return;

      const videoId = extractYouTubeId(url);
      const wrapper = document.querySelector(`[data-video="${videoId}"]`);
      //console.log(wrapper);
      if (!wrapper) return;

      if (app.cookies.cookieConsent.types.external && videoId) {
        // Create and configure the iframe for YouTube
        const iframe = document.createElement('iframe');
        iframe.src = `https://www.youtube.com/embed/${videoId}`;
        iframe.width = '560';
        iframe.height = '315';
        iframe.frameBorder = '0';
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
        iframe.allowFullscreen = true;
        iframe.title = 'YouTube video player';
        iframe.loading = 'lazy';
        iframe.style.cssText = 'aspect-ratio: 16/9; width: 100%; height: auto; display: block; margin: 1.5rem auto;';

        // Clear any existing content and append the iframe
        wrapper.innerHTML = '';
        wrapper.appendChild(iframe);

        element.style.display = 'none';
      } else {
        // Reset visibility and clear the wrapper content when external media is not allowed
        element.style.display = 'block';
        wrapper.innerHTML = '';
      }
    });
  });
});
